(function () {
  var STORAGE_PREFIX = "memoryfuelCustomerAvatar:";
  var AVATAR_ENDPOINT = "/apps/memory-fuel-study-auth?avatar=1";

  function validAvatarUrl(value) {
    return typeof value === "string" && (/^https:\/\//i.test(value) || /^data:image\/(?:png|jpeg|gif|webp|svg\+xml)[;,]/i.test(value));
  }

  function accountButtons() {
    return Array.prototype.slice.call(document.querySelectorAll(".account-button"));
  }

  function showAvatar(button, url) {
    var image = button.querySelector("[data-mf-customer-avatar]");
    if (!image) return;
    if (!validAvatarUrl(url)) {
      image.hidden = true;
      image.removeAttribute("src");
      return;
    }
    image.src = url;
    image.hidden = false;
  }

  function storeAvatar(customerId, url) {
    if (!customerId) return;
    try {
      if (validAvatarUrl(url)) localStorage.setItem(STORAGE_PREFIX + customerId, url);
      else localStorage.removeItem(STORAGE_PREFIX + customerId);
    } catch (_error) {}
  }

  function applyStoredAvatars() {
    accountButtons().forEach(function (button) {
      var customerId = button.getAttribute("data-mf-customer-id") || "";
      var cached = "";
      try { cached = localStorage.getItem(STORAGE_PREFIX + customerId) || ""; } catch (_error) {}
      showAvatar(button, cached);
    });
  }

  async function refreshAvatar() {
    var buttons = accountButtons();
    if (!buttons.length) return;
    try {
      var response = await fetch(AVATAR_ENDPOINT, {
        method: "GET",
        credentials: "same-origin",
        cache: "no-store",
        headers: { Accept: "application/json" }
      });
      if (!response.ok) return;
      var payload = await response.json();
      buttons.forEach(function (button) {
        var customerId = String(payload.customer_id || button.getAttribute("data-mf-customer-id") || "");
        if (customerId) button.setAttribute("data-mf-customer-id", customerId);
        storeAvatar(customerId, payload.avatar_url || "");
        showAvatar(button, payload.avatar_url || "");
      });
    } catch (_error) {}
  }

  window.addEventListener("memoryfuel:customer-avatar-updated", function (event) {
    var detail = event.detail || {};
    accountButtons().forEach(function (button) {
      var customerId = button.getAttribute("data-mf-customer-id") || "";
      if (detail.customerId && detail.customerId !== customerId) return;
      if (customerId) storeAvatar(customerId, detail.avatarUrl || "");
      showAvatar(button, detail.avatarUrl || "");
    });
  });

  window.addEventListener("storage", function (event) {
    if (event.key && event.key.indexOf(STORAGE_PREFIX) === 0) applyStoredAvatars();
  });

  applyStoredAvatars();
  refreshAvatar();
})();
